import {
  defaultCountries,
  parseCountry,
  ParsedCountry
} from "react-international-phone";

const countries: ParsedCountry[] = defaultCountries.map((country) => parseCountry(country));

  const countryOptions: { label: string; value: string; }[] = countries.map((country) => ({
    label: country.name,
    value: country.iso2.toUpperCase()
  }));

export default countryOptions;